<template>
  <transition
    name="profile-icon-classes-transition"
    enter-active-class="modal-show-slide-out"
    leave-active-class="modal-hiding-slide-in"
    v-if="!isHamburger"
  >
    <generic-modal
      @close="closeModalA()"
      :width="hamburgerMenuModal.width"
      :height="hamburgerMenuModal.height"
      :modalClass="hamburgerMenuModal.modalClass"
      :overflow="isLogoutModalOpen ? 'hidden' : hamburgerMenuModal.overflow"
      ref="modalRef"
      v-if="showProfileDrawerModal"
    >
      <template v-slot:header></template>
      <template v-slot:body>
        <div class="user-type-wrap" @close="closeModalA()">
          <!-- for logged out user -->
        <div class="login-wrap" :style="loginHeaderStyle">
          <div v-if="!isLoggedIn" class="profile-drawer logout flex-row">
            <!-- <div class="user-cover"><i class="hkfi-hamburger fs-18"></i></div> -->
            <div class="flex-column login-text">
              <div class="fs-18 fw-700">{{ modulePropsData?.title }}</div>
              <div class="fs-16 ">{{ modulePropsData?.subtitle }}</div>
            </div>
             <i class="hkfi-close-thin fs-24" :style="closeIconStyle"  @click="closeModalA('clicked')"></i>
   
          </div>

          <button
            class="btn bold primary"
            @click="handleLoginCTA()"
            v-if="!isLoggedIn"
          >
            {{ modulePropsData?.loginText }}
          </button>
          <!-- for logged in user -->
          <div v-if="isLoggedIn" class="profile-drawer">
            <div class="flex-row align-items-center">
              <div class="flex-column login-text">
                <div class="fs-16 bold">{{ profileData?.name }}</div>
              </div>
              <i class="hkfi-close-thin fs-24" :style="closeIconStyle"  @click="closeModalA('clicked')"></i>
   
            </div>
            <div class="fs-12 ">
              <span v-if="mobileNo">+91 {{ mobileNo }}</span
              ><span v-if="profileData?.email" > | </span
              ><span> {{ profileData?.email }}</span>
            </div>
            <div class="pt5">
              <span
                class="fs-12 underlined"
                @click="handleEditProfile()"
                ><i class="hkfi-edit-icon pr4" ></i>Edit</span>
            </div>
          </div>
        </div>

          <profile-drawer-modal
            v-if="showProfileDrawerModal && clientPlatform !== 'Web'"
            :logoutModalOpened="logoutModalOpened"
          ></profile-drawer-modal>
        </div>
      </template>
      <template v-slot:footer> </template>
    </generic-modal>
  </transition>
</template>

<script>
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation } from "../helpers/storeKeys";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import ProfileDrawerModal from "./ProfileDrawerModal.vue";
import GenericModal from "./GenericModal.vue";
import {
  EVENT_HAMBURGER_CLOSED,
  EVENT_LOGIN_CTA_CLICKED,
  EVENT_LOGOUT_CLICK,
  EVENT_PROFILE_CLICK,
} from "../helpers/analyticsEvents";
export default {
  name: "MiniLogin",
  props: ["moduleProps"],
  data() {
    return {
      modulePropsData: {},
      mobileNo: LocalStorageFunc.getUserMobileNo() || "",
      showLogoutModal: false,
      LogoutModalDim: {
        width: "100vw",
        height: "auto",
        padding: "0px",
        paddingTop: "0px",
        paddingBottom: "0px",
      },
      staticImgBaseUrl,
      hamburgerMenuModal: {
        width: "100vw",
        height: "calc(100vh - 0px)",
        modalClass: "profile-Modal modal-outer",
        overflow: "auto",
      },
      isLogoutModalOpen: false,
      clientPlatform,
    };
  },
  components: {
    ProfileDrawerModal,
    GenericModal,
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    setTimeout(() => {
      document.body.classList.add("body-stop-scroll-mobile");
    }, 1);
  },
  methods: {
    closeModalA(type = "") {
      this.$store.commit(keyMapsMutation.UPDATE_IS_HAMBURGER, false);
      document.body.classList.remove("body-stop-scroll-mobile");
      EVENT_HAMBURGER_CLOSED();
      if (type == "clicked") {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_PROFILE_DRAWER_MODAL,
          false
        );
      } else {
        setTimeout(() => this.$emit("close-profile-modal"), 2000);
      }
    },
    handleLoginCTA() {
      this.closeModalA();
      EVENT_LOGIN_CTA_CLICKED({ sectionName: "hamburger" });
      EVENT_PROFILE_CLICK({userAction:'login'});
      Utility.sendToLoginScreen();
    },
    handleEditProfile() {
      EVENT_PROFILE_CLICK({userAction:'edit profile'});
      Utility.redirectToLinkRewrite("/my-profile");
    },
    logoutModalOpened(value) {
      if (value && this.$refs.modalRef?.$el?.children[0]) {
        this.$refs.modalRef.$el.children[0].scrollTop = 0;
      }
      EVENT_LOGOUT_CLICK();
      this.isLogoutModalOpen = value;
    },
  },
  computed: {
    isLoggedIn() {
      return LocalStorageFunc.isLoggedIn();
    },
    showProfileDrawerModal() {
      return this.$store?.state?.Auth?.showProfileDrawerModal;
    },
    profileData() {
      return this.$store.state.Profile.profileData;
    },
    isHamburger() {
      return this.$store?.state?.Auth?.isHamburger;
    },
    loginHeaderStyle() {
      return {'background-image': `url(${this.modulePropsData.hamburgerHeaderImage})`, color: this.modulePropsData?.hamburgerHeaderTextColor}
    },
    closeIconStyle() {
      return {color:this.modulePropsData.closeIconColor};
    }
  },
};
</script>

<style></style>
